import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCopyright: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCopyright"><Path d="M20.5 11.5C20.5 16.4706 16.4706 20.5 11.5 20.5C6.52944 20.5 2.5 16.4706 2.5 11.5C2.5 6.52944 6.52944 2.5 11.5 2.5C16.4706 2.5 20.5 6.52944 20.5 11.5Z" stroke="currentColor"/><Path d="M14.9649 9.5C14.2733 8.3044 12.9806 7.5 11.5 7.5C9.29086 7.5 7.5 9.29086 7.5 11.5C7.5 13.7091 9.29086 15.5 11.5 15.5C12.9806 15.5 14.2733 14.6956 14.9649 13.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconCopyright;
